import { render, staticRenderFns } from "./downPopup.vue?vue&type=template&id=c49ccf02&scoped=true&"
import script from "./downPopup.vue?vue&type=script&lang=js&"
export * from "./downPopup.vue?vue&type=script&lang=js&"
import style0 from "./downPopup.vue?vue&type=style&index=0&id=c49ccf02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49ccf02",
  null
  
)

export default component.exports